module.exports = __webpack_public_path__ + "tell_a_friend_illustration.693bfe70dcb7561ba42253f016ad1e41.svg";